import { FULL_DOCUMENTS, GLOBAL_CATALOGS, HAS_DETAILS } from '../types';
import { queryContentList } from './cmsAction';

export const onChangeDocumentsTabsItem = (value, title) => async (dispatch, getState) => {
  await dispatch({
    type: FULL_DOCUMENTS.Loading,
    payload: true
  });
  await dispatch({
    type: FULL_DOCUMENTS.Value,
    payload: value
  });
  await dispatch(queryDocumentsList({ contentCode: value, title }));
};

export const onChangeDocumentsTabsLoader = (value, title) => async (dispatch, getState) => {
  await dispatch({
    type: FULL_DOCUMENTS.Value,
    payload: value
  });
};

export const queryDocumentsList = ({ contentCode, title, ruleTag, page = 1, rowsPerPage = 10 }) => async (dispatch, getState) => {
  const response = await dispatch(queryContentList({ contentCode, hasDetails: HAS_DETAILS.True, ruleTag, title, page, rowsPerPage }));
  await dispatch({
    type: FULL_DOCUMENTS.List,
    payload: response
  });

  setTimeout(() => {
    dispatch({
      type: FULL_DOCUMENTS.Loading,
      payload: false
    });
  }, 260);
};

export const queryDocumentsMenus = (list = []) => (dispatch, getState) => {
  dispatch({
    type: GLOBAL_CATALOGS.Documents.Root,
    payload: list
  });
};
